import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50 backdrop-blur-sm bg-white/95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center group">
            <img 
              src="/logo.png" 
              alt="Happy Yatra Travels Logo" 
              className="h-12 md:h-16 w-auto object-contain"
            />
          </Link>
          
          <div className="flex items-center gap-4">
            <nav className={`hidden md:flex gap-8 items-center`}>
              <Link 
                to="/" 
                className={`font-medium transition-colors duration-300 relative py-2 ${
                  isActive('/') 
                    ? 'text-primary-orange after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-primary-orange' 
                    : 'text-gray-800 hover:text-primary-orange'
                }`}
              >
                Home
              </Link>
              <Link 
                to="/packages" 
                className={`font-medium transition-colors duration-300 relative py-2 ${
                  isActive('/packages') 
                    ? 'text-primary-orange after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-primary-orange' 
                    : 'text-gray-800 hover:text-primary-orange'
                }`}
              >
                Packages
              </Link>
              <Link 
                to="/spiritual" 
                className={`font-medium transition-colors duration-300 relative py-2 ${
                  isActive('/spiritual') 
                    ? 'text-primary-orange after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-primary-orange' 
                    : 'text-gray-800 hover:text-primary-orange'
                }`}
              >
                Spiritual
              </Link>
              <Link 
                to="/gallery" 
                className={`font-medium transition-colors duration-300 relative py-2 ${
                  isActive('/gallery') 
                    ? 'text-primary-orange after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-primary-orange' 
                    : 'text-gray-800 hover:text-primary-orange'
                }`}
              >
                Gallery
              </Link>
              <Link 
                to="/b2b" 
                className={`font-medium transition-colors duration-300 relative py-2 ${
                  isActive('/b2b') 
                    ? 'text-primary-orange after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-primary-orange' 
                    : 'text-gray-800 hover:text-primary-orange'
                }`}
              >
                B2B Partners
              </Link>
              <Link 
                to="/blog" 
                className={`font-medium transition-colors duration-300 relative py-2 ${
                  isActive('/blog') 
                    ? 'text-primary-orange after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-primary-orange' 
                    : 'text-gray-800 hover:text-primary-orange'
                }`}
              >
                Blog
              </Link>
              <Link 
                to="/services" 
                className={`font-medium transition-colors duration-300 relative py-2 ${
                  isActive('/services') 
                    ? 'text-primary-orange after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-primary-orange' 
                    : 'text-gray-800 hover:text-primary-orange'
                }`}
              >
                Services
              </Link>
              <Link 
                to="/about" 
                className={`font-medium transition-colors duration-300 relative py-2 ${
                  isActive('/about') 
                    ? 'text-primary-orange after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-primary-orange' 
                    : 'text-gray-800 hover:text-primary-orange'
                }`}
              >
                About Us
              </Link>
              <a 
                href="/#contact"
                onClick={(e) => {
                  if (location.pathname !== '/') {
                    e.preventDefault();
                    window.location.href = '/#contact';
                  }
                }}
                className="font-medium transition-colors duration-300 relative py-2 text-gray-800 hover:text-primary-orange"
              >
                Contact
              </a>
            </nav>
            <button 
              className="md:hidden flex flex-col gap-1.5 p-2 focus:outline-none" 
              onClick={toggleMenu}
              aria-label="Toggle menu"
            >
              <span className={`w-6 h-0.5 bg-gray-800 transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
              <span className={`w-6 h-0.5 bg-gray-800 transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
              <span className={`w-6 h-0.5 bg-gray-800 transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <nav className={`md:hidden transition-all duration-300 ease-in-out ${
          isMenuOpen 
            ? 'max-h-[600px] opacity-100 visible' 
            : 'max-h-0 opacity-0 invisible'
        } overflow-hidden`}>
          <div className="flex flex-col py-4 space-y-1 border-t border-gray-200">
            <Link 
              to="/" 
              className={`px-4 py-3 font-medium transition-colors ${
                isActive('/') ? 'text-primary-orange bg-primary-orange/10' : 'text-gray-800 hover:text-primary-orange hover:bg-gray-50'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Home
            </Link>
            <Link 
              to="/packages" 
              className={`px-4 py-3 font-medium transition-colors ${
                isActive('/packages') ? 'text-primary-orange bg-primary-orange/10' : 'text-gray-800 hover:text-primary-orange hover:bg-gray-50'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Packages
            </Link>
            <Link 
              to="/spiritual" 
              className={`px-4 py-3 font-medium transition-colors ${
                isActive('/spiritual') ? 'text-primary-orange bg-primary-orange/10' : 'text-gray-800 hover:text-primary-orange hover:bg-gray-50'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Spiritual
            </Link>
            <Link 
              to="/gallery" 
              className={`px-4 py-3 font-medium transition-colors ${
                isActive('/gallery') ? 'text-primary-orange bg-primary-orange/10' : 'text-gray-800 hover:text-primary-orange hover:bg-gray-50'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Gallery
            </Link>
            <Link 
              to="/b2b" 
              className={`px-4 py-3 font-medium transition-colors ${
                isActive('/b2b') ? 'text-primary-orange bg-primary-orange/10' : 'text-gray-800 hover:text-primary-orange hover:bg-gray-50'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              B2B Partners
            </Link>
            <Link 
              to="/blog" 
              className={`px-4 py-3 font-medium transition-colors ${
                isActive('/blog') ? 'text-primary-orange bg-primary-orange/10' : 'text-gray-800 hover:text-primary-orange hover:bg-gray-50'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Blog
            </Link>
            <Link 
              to="/services" 
              className={`px-4 py-3 font-medium transition-colors ${
                isActive('/services') ? 'text-primary-orange bg-primary-orange/10' : 'text-gray-800 hover:text-primary-orange hover:bg-gray-50'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              Services
            </Link>
            <Link 
              to="/about" 
              className={`px-4 py-3 font-medium transition-colors ${
                isActive('/about') ? 'text-primary-orange bg-primary-orange/10' : 'text-gray-800 hover:text-primary-orange hover:bg-gray-50'
              }`}
              onClick={() => setIsMenuOpen(false)}
            >
              About Us
            </Link>
            <a 
              href="/#contact"
              onClick={(e) => {
                setIsMenuOpen(false);
                if (location.pathname !== '/') {
                  e.preventDefault();
                  window.location.href = '/#contact';
                }
              }}
              className="px-4 py-3 font-medium transition-colors text-gray-800 hover:text-primary-orange hover:bg-gray-50"
            >
              Contact
            </a>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
